import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="file-show"
export default class extends Controller {
  
  static values = { tab: String }

  setUrl(event) {
    const tab = event.currentTarget.dataset.tab
    if (tab) {
      history.pushState({}, "", window.location.pathname + "?tab=" + tab)
    }
  }
  
}
